import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddTeamMessage = () => {
  const [formData, setFormData] = useState({
    title: '',
    type: 'horizontal',
    is_active: true,
    image: null,
    video: null,
    video_url: ''
  });
  const [preview, setPreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const isVideoType = formData.type === 'video';

  const handleChange = (e) => {
    const { name, value, files, checked } = e.target;
    if (name === 'image') {
      const file = files[0];
      setFormData((prev) => ({ ...prev, image: file }));
      setPreview(file ? URL.createObjectURL(file) : null);
    } else if (name === 'video') {
      const file = files[0];
      setFormData((prev) => ({ ...prev, video: file }));
      setVideoPreview(file ? URL.createObjectURL(file) : null);
    } else if (name === 'is_active') {
      setFormData((prev) => ({ ...prev, is_active: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const data = new FormData();
      data.append('title', formData.title);
      data.append('type', formData.type);
      data.append('is_active', formData.is_active ? 1 : 0);
      if (formData.image) {
        data.append('image', formData.image);
      }
      if (formData.video) {
        data.append('video', formData.video);
      }
      if (formData.video_url) {
        data.append('video_url', formData.video_url);
      }

      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/message`, data);

      toast.success('✅ Advertisement added successfully!');

      // Reset form
      setFormData({
        title: '',
        type: 'horizontal',
        is_active: true,
        image: null,
        video: null,
        video_url: ''
      });
      setPreview(null);
      setVideoPreview(null);
    } catch (error) {
      console.error(error);
      toast.error('❌ Failed to add advertisement!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add advertising</h4>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">
            Title
          </label>
          <input type="text" className="form-control" id="title" name="title" value={formData.title} onChange={handleChange} required />
        </div>

        <div className="mb-3">
          <label htmlFor="type" className="form-label">
            Type
          </label>
          <select className="form-control" id="type" name="type" value={formData.type} onChange={handleChange} required>
            <option value="horizontal">Horizontal</option>
            <option value="vertical">Vertical</option>
            <option value="video">Video</option>
          </select>
        </div>

        {!isVideoType && (
          <div className="mb-3">
            <label htmlFor="image" className="form-label">
              Image
            </label>
            <input type="file" className="form-control" id="image" name="image" accept="image/*" onChange={handleChange} />
            {preview && (
              <div className="mt-2">
                <p className="text-white">Preview:</p>
                <img src={preview} alt="preview" width={150} className="rounded" />
              </div>
            )}
          </div>
        )}

        {isVideoType && (
          <>
            <div className="mb-3">
              <label htmlFor="video" className="form-label">
                Video File (optional)
              </label>
              <input type="file" className="form-control" id="video" name="video" accept="video/*" onChange={handleChange} />
              {videoPreview && (
                <div className="mt-2">
                  <p className="text-white">Preview:</p>
                  <video src={videoPreview} width={250} className="rounded" controls>
                    <track kind="captions" />
                  </video>
                </div>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="video_url" className="form-label">
                Video URL (YouTube / Shorts / other)
              </label>
              <input
                type="text"
                className="form-control"
                id="video_url"
                name="video_url"
                value={formData.video_url}
                onChange={handleChange}
                placeholder="https://youtube.com/shorts/... or https://youtu.be/..."
              />
            </div>
          </>
        )}

        <div className="mb-3 form-check">
          <input type="checkbox" className="form-check-input" id="is_active" name="is_active" checked={formData.is_active} onChange={handleChange} />
          <label htmlFor="is_active" className="form-check-label text-white">
            Active
          </label>
        </div>

        <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
          {loading ? 'Adding...' : 'Add New'}
        </button>
      </form>
    </div>
  );
};

export default AddTeamMessage;